import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { useCommon } from "../../Common/useCommon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";

export const useProdServerAccessList = () => {

    const { getValuePermission } = useCommon();
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [showRequestPopup, setShowRequestPopup] = useState(false);
    const [editData, setEditData] = useState(false);
    const [loader, setLoader] = useState(false);
    const [dropDownOption, setDropDownOption] = useState({});
    const [filterValues, setFilterValues] = useState({ hoveredRange: [] });
    const [headerChecked, setHeaderChecked] = useState(false);
    const [rowData, setRowData] = useState([]);
    const tagRef = useRef(null);

    const columnDefs = [
        {
            field: "checkbox",
            headerName: "",
            headerComponent: () => {
                return (
                    <div className="w100">
                        <input type="checkbox" onChange={(e) => { handleSelectAll(e) }} checked={headerChecked} />
                    </div>
                )
            },
            width: 40,
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) && <input type="checkbox" checked={params.data.is_checked} onChange={(e) => handleSelectAll(e, params)} />
                        }

                    </div>

                )
            }
        },
        {
            field: "edit",
            headerName: "Edit",
            width: 40,
            cellStyle: { textAlign: "center" },
            headerClass: "ag-text-center",
            hide: filterValues?.status?.request_status_key !== "is_pending",
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                let allowEdit = false;
                if (params?.data?.approver_user_code === dropDownOption?.userCode || params?.data?.requested_user_code === dropDownOption?.userCode) {
                    allowEdit = true;
                }
                return <div>{allowEdit && params.data?.request_status_id === pendingId ?
                    <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => { setShowRequestPopup(true); setEditData(params) }} /></div> :
                    <></>}</div>
            }
        },
        {
            field: "request_status_name",
            headerName: "Status",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id;
                const rejectedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_rejected" })?.request_status_id;
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const grantId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_grant" })?.request_status_id;
                const partialId = -1;
                return (
                    <div style={{ cursor: "pointer", fontSize: "large" }}>
                        {params.data.request_status_id === approveId && <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "green" }} />}
                        {params.data.request_status_id === rejectedId && <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "red" }} />}
                        {params.data.request_status_id === pendingId && <FontAwesomeIcon icon="fa-solid fa-clock" style={{ color: "#d4d404" }} />}
                        {params.data.request_status_id === partialId && <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: "green" }} />}
                        {params.data.request_status_id === grantId && <FontAwesomeIcon icon="fa-solid fa-check-double" style={{ color: "green" }} />}
                    </div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Action",
            width: 150,
            cellStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        name="server-access-action"
                                        onChange={(e) => { handleRequest(e.target.value, params?.data?.server_access_request_id, false) }
                                        }
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        name="server-access-action"
                                        onChange={(e) => { handleRequest(e.target.value, params?.data?.server_access_request_id, false) }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: "project_name",
            headerName: "Project",
            width: 120,
        },
        {
            field: "server_name",
            headerName: "Server Name",
            width: 110,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
        {

            field: "database_name",
            headerName: "Database Name",
            width: 140,
            cellRenderer: (params) => {
                return (
                    <div title={params?.value}>{params?.value}</div>
                )
            }
        },
        {
            field: "request_access_minutes",
            headerName: "Time Period",
            width: 80,
            cellRenderer: (params) => {
                return (
                    <div className="text-center">{params?.value ? params?.value + ' min' : ""}</div>
                )
            }
        },
        {
            field: "requested_user_display_name",
            headerName: "Request By",
            width: 120,
        },
        {
            field: "approver_user_display_name",
            headerName: "Request To",
            width: 120,
        },
        {
            field: "remark",
            headerName: "Reason",
            minWidth: 260,
            cellRenderer: function (params) {
                return (
                    <div title={params?.value}>
                        {params?.value}
                    </div>
                );
            },

        },
        {
            headerName: "Apply Date", field: "apply_datetime", width: 130, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.apply_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Approve Date",
            field: "approve_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.approve_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
    ]

    useEffect(() => {
        callautopopulate("request_status", "all_users", "projects", "user_info").then((res) => {
            setDropDownOption({
                statusOptions: res?.request_status,
                users: _.sortBy(res?.all_users, "user_display_name"),
                projects: res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)),
                userCode: res?.user_info?.[0]?.user_code,
            })
            setFilterValues((prev) => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })
    }, [])

    useEffect(() => {
        if (filterValues?.status?.request_status_id && filterValues?.apiCall) {
            getRequestedData();
        }
    }, [filterValues?.status?.request_status_id, filterValues?.apiCall]);
    const getRequestedData = async (key) => {
        try {
            setLoader(true);
            setHeaderChecked(false);
            const payload = {
                "project_ids": key === "projects" ? "" : _.pluck(filterValues?.projects, "project_id")?.toString(),
                "request_status_id": filterValues?.status?.request_status_id || 0,
                "from_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : "",
                "to_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : "",
                "users": key === "users" ? "" : _.pluck(filterValues?.all_users, "user_code")?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSERVERACCESSLISTDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.server_request_list?.sort((a, b) => new Date(b?.approve_datetime) - new Date(a?.approve_datetime));
                setRowData(data);
                setLoader(false);
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            console.error("Error: ", error);
              setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setLoader(false);
        }
    }

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value),
        });
        setFilterValues((prev) => ({ ...prev, status: data, apiCall: true }));
        getRequestedData(parseInt(e.target.value))
    };

    const handleRequest = async (status, server_access_request_id, actionAll) => {
        try {
            if(actionAll && _.isEmpty(server_access_request_id)) {
                showInfo('Info', "Please select request to approve/reject");
                return;
            }
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: status })
            const payload = {
                "server_access_request_ids": server_access_request_id?.toString() || 0,
                "request_status_id": requestStatus?.request_status_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTAPPROVESERVERACCESSREQUEST"), payload);
            if (res?.body?.data) {
                showSuccess('Success', res?.body?.message);
                getRequestedData();
            } else {
                showError("Error", res?.body?.message);
                if (res?.body?.StatusCode === 202) {
                    getRequestedData();
                }
            }
        } catch (error) {
            console.error("Error: ", error)
        }
    }

    const handleSelectAll = (e, rowdata) => {
        const data = [...rowData];
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = e?.target?.checked;
            setRowData(data);
            if(!e?.target?.checked) {
                setHeaderChecked(false);
            } else if(e?.target?.checked && data?.length === _.filter(data, item => item?.is_checked)?.length) {
                setHeaderChecked(true);
            }
        } else {
            data.map((item) => item.is_checked = e.target.checked);
            setHeaderChecked(!headerChecked)
            setRowData(data);
        }
    }

    return useMemo(() => ({
        getRequestedData, showRequestPopup, setShowRequestPopup, editData, setEditData, tagRef, dropDownOption, filterValues, setFilterValues, handleStatusChange, loader, columnDefs, rowData, handleRequest
    }), [getRequestedData, showRequestPopup, setShowRequestPopup, editData, setEditData, tagRef, dropDownOption, filterValues, setFilterValues, handleStatusChange, loader, columnDefs, rowData, handleRequest])
}